module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="alert-message quickshopbox">\n    <div>\n        ';
 product = content.content 
__p+='\n        ';
 current_variant = product.variants ? product.variants[0] : product 
__p+='\n        \n        <div class="quickshop-container">\n            \n            <div itemscope itemtype="http://schema.org/Product">\n\n                <meta itemprop="url" content="'+
((__t=( product.url ))==null?'':__t)+
'">\n                <meta itemprop="image" content="'+
((__t=( product.images[0] ))==null?'':__t)+
'">\n\n                <div class="grid product-single">\n                    \n                    <div class="grid__item large--one-half text-center product-media">\n                        <div class="product-single__photos" id="ProductPhoto">\n                            ';
 featured_image = product.featured_image 
__p+='\n                            <img src="'+
((__t=( featured_image ))==null?'':__t)+
'" alt="" id="ProductPhotoImg">\n                        </div>\n\n                        ';
 if (product.images.length > 1) { 
__p+='\n                        <ul class="product-single__thumbnails grid-uniform" id="ProductThumbs">\n                            ';
 _.each(product.images, function(image){ 
__p+='\n                            <li class="grid__item one-quarter">\n                                <a href="'+
((__t=( image ))==null?'':__t)+
'" class="product-single__thumbnail" alt="">\n                                    <img src="'+
((__t=( image ))==null?'':__t)+
'" >\n                                </a>\n                            </li>    \n                            ';
 }) 
__p+='\n                        </ul>\n                        ';
 } 
__p+='\n                    </div>\n                    \n                    <div class="grid__item large--one-half">\n\n                        <h1 itemprop="name">'+
((__t=( product.title ))==null?'':__t)+
'</h1>\n\n                        <div itemprop="offers" itemscope itemtype="http://schema.org/Offer">\n                            \n                            <meta itemprop="priceCurrency" content="{{ shop.currency }}">\n\n                            <link itemprop="availability" href="http://schema.org/'+
((__t=( product.available ? 'InStock' : 'OutOfStock' ))==null?'':__t)+
'">\n\n                            <form action="/cart/add" method="post" enctype="multipart/form-data" id="AddToCartForm" class="form-vertical">\n                                \n                                <!-- Swatches -->\n                                ';
 productExtra = product.extraData.product 
__p+='\n                                ';
 colorNum = 2 
__p+='\n                                ';
 _.each(productExtra.options, function(option,index){ 
__p+='\n                                    ';
 optionName = option.name.toLowerCase() 
__p+='\n                                    '+
((__t=( optionName ))==null?'':__t)+
'\n                                    ';
 if (optionName == "color") { 
__p+='\n                                        ';
 colorNum = index 
__p+='\n                                    ';
 } 
__p+='\n                                ';
 }) 
__p+='    \n                                '+
((__t=( colorNum ))==null?'':__t)+
'\n                                \n                                ';
 if (product.available) { 
__p+='\n                                    ';
 _.each(productExtra.options, function(option,index){ 
__p+='\n                                        ';
 optTitle = option.name.toLowerCase() 
__p+='\n                                		<div class="selector-wrapper 1r-swatch">\n                                			<div class="swatch-label">'+
((__t=( option.name ))==null?'':__t)+
'</div>\n                                            ';
 if (optTitle == "color") { 
__p+='\n                                                <ul class="swatches colors clearfix" data-option="'+
((__t=( index ))==null?'':__t)+
'">\n                                                    ';
 activeClass = "active" 
__p+='\n                                                    ';
 _.each(option.values, function(value){ 
__p+='\n                                                        ';
 swatchImg = "" 
__p+='\n                                                        ';
 _.each(product.variants, function(variant){ 
__p+='\n                                                            ';
 optionIndex = colorNum 
__p+='\n                                                            ';
 if (variant.available && variant.options[optionIndex]) { 
__p+='\n                                                                ';
 swatchImg = variant.featured_image.src 
__p+='\n                                                            ';
 } 
__p+='\n                                                        ';
 }) 
__p+='\n                                						';
 if (swatchImg != '') { 
__p+='\n                                							<li data-select="'+
((__t=( value.toLowerCase() ))==null?'':__t)+
'" data-name="'+
((__t=( value ))==null?'':__t)+
'" data-image="'+
((__t=( swatchImg ))==null?'':__t)+
'" class="swatch swatch-'+
((__t=( value.toLowerCase() ))==null?'':__t)+
' '+
((__t=( activeClass ))==null?'':__t)+
'"><span class="tooltip hidden">'+
((__t=( value ))==null?'':__t)+
'</span></li>\n                                						    ';
 activeClass = "" 
__p+='\n                                                        ';
 } 
__p+='\n                                                    ';
 }) 
__p+='\n                                				</ul>\n                                            ';
 } else { 
__p+='\n                                                <ul class="swatches '+
((__t=( optTitle ))==null?'':__t)+
's clearfix" data-option="'+
((__t=( index ))==null?'':__t)+
'">\n                                					';
 activeClass = "active" 
__p+='\n                                                    ';
 _.each(option.values, function(value){ 
__p+='\n                                						<li data-select="'+
((__t=( value.toLowerCase() ))==null?'':__t)+
'" data-name="'+
((__t=( value ))==null?'':__t)+
'" class="swatch swatch-'+
((__t=( value.toLowerCase() ))==null?'':__t)+
' '+
((__t=( activeClass ))==null?'':__t)+
'">'+
((__t=( value ))==null?'':__t)+
'</li>\n                                					    ';
 activeClass = "" 
__p+='\n                                                    ';
 }) 
__p+='\n                                				</ul>\n                                            ';
 } 
__p+='\n                                		</div>\n                                    ';
 }) 
__p+='\n                                ';
 } 
__p+='\n                                <!-- Swatches End -->\n\n                                <select name="id" id="productSelect" class="product-single__variants">\n                                ';
 _.each(product.variants, function(variant){ 
__p+='\n                                    ';
 if (variant.available) { 
__p+='\n                                    <option ';
 if (variant == current_variant) { 
__p+='selected="selected"';
 } 
__p+=' data-sku="'+
((__t=( variant.sku ))==null?'':__t)+
'" value="'+
((__t=( variant.id ))==null?'':__t)+
'">\n                                        '+
((__t=( variant.title ))==null?'':__t)+
' - '+
((__t=( Shopify.formatMoney(variant.price) ))==null?'':__t)+
'\n                                    </option>\n                                    ';
 } else { 
__p+='\n                                    <option disabled="disabled">\n                                        '+
((__t=( variant.title ))==null?'':__t)+
' - Sold Out\n                                    </option>    \n                                    ';
 } 
__p+='\n                                ';
 }) 
__p+='\n                                </select>\n                                \n                                <span class="visually-hidden">Regular price</span>\n                                \n                                <span id="ProductPrice" class="h2" itemprop="price" content="'+
((__t=( current_variant.price/100 ))==null?'':__t)+
'">\n                                    '+
((__t=( Shopify.formatMoney(current_variant.price) ))==null?'':__t)+
'\n                                </span>\n                                \n                                ';
 if ( product.compare_at_price_max > product.price ) { 
__p+='\n                                <span class="visually-hidden">Special Price</span>\n                                <p id="ComparePrice">\n                                    Compare '+
((__t=( current_variant.compare_at_price ))==null?'':__t)+
'\n                                </p>\n                                ';
 } 
__p+='\n\n                                <label for="Quantity" class="quantity-selector">Quantity</label>\n                                <input type="number" id="Quantity" name="quantity" value="1" min="1" class="quantity-selector">\n\n                                <button type="submit" name="add" id="AddToCart" class="btn">\n                                    <span id="AddToCartText">Add to Cart</span>\n                                </button>\n                                \n                            </form>\n                        </div>\n\n                        <div class="product-description rte" itemprop="description">'+
((__t=( product.description ))==null?'':__t)+
'</div>\n\n                    </div>\n\n                </div>\n\n            </div>\n        </div>\n    </div>\n</div>';
}
return __p;
};
